import React, { useRef, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import logoComapny from "../../assets/img/new_logo.jpg";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Navigate, useNavigate } from "react-router-dom";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "./Login.css";
import Preloading from "../Preload/Preloading";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import {I18nextProvider} from "react-i18next";
// import i18next from "i18next";
import { useMemo } from "react";
import { useEffect } from "react";
import helpers from "../../assets/js/helper";
import host from "../../assets/js/Host";
import { setUserImage } from "../../reduxStore/UserReducer";
import axios from "../../assets/js/AxiosInterceptors";
import { useTheme } from '@mui/material/styles';

const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

const Login = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [showPasword, setShowPassword] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenWidth(window.innerWidth);
    });
    const handleAutoFill = (event) => {
      if (event.animationName === "onAutoFillStart") {
        // Check if the username field is autofilled
        if (
          usernameRef &&
          usernameRef?.current &&
          usernameRef.current.value !== ""
        ) {
          usernameRef.current.focus();
        }

        // Check if the password field is autofilled
        if (
          passwordRef &&
          passwordRef?.current &&
          passwordRef.current.value !== ""
        ) {
          passwordRef.current.focus();
        }
      }
    };

    document.addEventListener("animationstart", handleAutoFill);
    return () => {
      document.removeEventListener("animationstart", handleAutoFill);
    };
  }, []);

  const clearCookies = () => {
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  };
  
  const login = async (e) => {
    e?.preventDefault();
    if (username?.length < 3) {
      return toast.error(`Username is short`);
    } else if (password?.length < 3) {
      return toast.error(`Password must be more than 3 char`);
    }
    setLoading(true);
    localStorage.clear();
    clearCookies();
    
    var options = {
      body: JSON.stringify({
        username: username,
        password: password,
        device_type: "web",
      }), //formData,
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
    };
    try {
      var check = false;
      await helpers.http(
        "login",
        options,
        async (responseJson) => {
          // onSucess

          if (responseJson.status === false) {
            check = true;
            toast.error(responseJson.data.data.text);
            setLoading(false);
          } else if (responseJson.status === true) {
            if (
              responseJson?.data?.user_image &&
              responseJson?.data?.user_image?.length
            ) {
              localStorage.setItem(
                "userImage",
                responseJson?.data?.user_image[
                  responseJson?.data?.user_image?.length - 1
                ]?.path
              );
              dispatch(
                setUserImage(
                  responseJson?.data?.user_image[
                    responseJson?.data?.user_image?.length - 1
                  ]?.path
                )
              );
            }
            check = true;
            var headers = {
              jwt: responseJson.data.token,
            };
            axios({
              url: host + "setting/default_settings",
              method: "get",
              headers: headers,
            })
              .then((res) => {
                setLoading(false);
                if (res.data.status === true) {
                  //console.log(res.data)
                  localStorage.setItem(
                    "defaultSettings",
                    JSON.stringify(res.data.data)
                  );
                } else if (res.data.status === false) {
                  localStorage.setItem("defaultSettings", null);
                }
              })
              .catch((err) => {
                setLoading(false);
              })
              .finally(() => {
                check = true;
                setLoading(false);
                let token = responseJson.data.token;
                let default_route = responseJson.data.default_route;
                console.log("sss", responseJson.data);
                let status = responseJson.status;
                cookies.set("status", status, { path: "/" });
                cookies.set("username", responseJson.data.username, {
                  path: "/",
                });
                localStorage.setItem(
                  "userData",
                  JSON.stringify(responseJson.data)
                );
                cookies.set("user_id", responseJson.data.user_id, {
                  path: "/",
                });
                localStorage.setItem(
                  "roles",
                  JSON.stringify(responseJson.data.roles)
                );
                cookies.set("token", token, {
                  path: "/",
                  expires: new Date(Date.now() + 60480000),
                });
                cookies.set("default_route", default_route);
                navigate("ticket-system/"+default_route);
              });
          }
        },
        async () => {
          check = true;
          toast.error("Network Error");
          setLoading(false);
        },
        async () => {
          setLoading(false);
        },
        "Login"
      );
      setLoading(false);
      if (!check) {
        toast.error("Network Error");
      }
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent form submission
      if (event.target === usernameRef.current) {
        console.log("sdfsdfsdfsdfsdfsdfsdfds");
        passwordRef.current.focus();
      }
    }
  };

  if (cookies.get("token")) {
    if(cookies.get("default_route"))
    navigate("ticket-system/"+cookies.get("default_route"));
    else
    navigate("ticket-system/welcome_page");
  } else
    return (
      <LoginPage className="LoginPage">
        {loading ? <Preloading /> : null}

        <CustomeLoginWrapper screenWidth={screenWidth}>
          <CustomeLeft screenWidth={screenWidth}>
            <Box
              sx={{
                "& span": {
                  fontFamily: "'Lobster', cursive",
                },
              }}
            >
              <span
                className="titleName"
                style={{
                  color: "#1e6a99",
                  fontSize: "25px",
                  marginRight: "5px",
                }}
              >
                Ticket
              </span>
              <span
                className="titleName"
                style={{ color: "#fe3847", fontSize: "25px" }}
              >
                System
              </span>
            </Box>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: screenWidth<=1300?'89%':"91%",
                top: "38px",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: "28px",
                  fontWeight: "bold",
                  position: "relative",
                  top: 30,
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Sign in
              </Typography>

              <TextField
                sx={{
                  mt: 8,
                  width: "100%",
                  "& .muiltr-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
                    // left:'30px'
                    borderRadius: "10px",
                  },
                  "& .muiltr-1sumxir-MuiFormLabel-root-MuiInputLabel-root": {
                    left: "15px",
                  },
                  "& .muiltr-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    padding: "0 20px",
                  },
                }}
                id="outlined-error-helper-text"
                label={"Username"}
                defaultValue=""
                value={username}
                autoComplete="new-password"
                inputRef={usernameRef}
                focused
                onKeyDown={handleKeyPress}
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
                required
              />
              <Box sx={{ position: "relative" }}>
                <TextField
                  sx={{
                    mt: 2,
                    width: "100%",
                    "& .muiltr-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
                      // left:'30px'
                      borderRadius: "10px",
                    },
                    "& .muiltr-1sumxir-MuiFormLabel-root-MuiInputLabel-root": {
                      left: "15px",
                    },
                    "& .muiltr-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      padding: "0 20px",
                    },
                  }}
                  id="outlined-error-helper-text"
                  inputRef={passwordRef}
                  label={"Password"}
                  type={showPasword ? "text" : "password"}
                  defaultValue=""
                  focused
                  onKeyDown={(event) => {
                    if (event.key == "Enter") {
                      login();
                    }
                  }}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  required
                />
                {!showPasword ? (
                  <VisibilityOutlinedIcon
                    sx={{
                      position: "absolute",
                      top: "33px",
                      color: "#958a8a",
                      right: "5%",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(true)}
                  />
                ) : (
                  <VisibilityOffOutlinedIcon
                    sx={{
                      position: "absolute",
                      top: "33px",
                      right: "5%",
                      color: "#958a8a",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(false)}
                  />
                )}
              </Box>
            </Box>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                mt: 8,
              }}
            >
              <Button
                id="sign_in_div_2"
                variant="contained"
                disabled={!username || !password}
                sx={{
                  backgroundColor: "rgb(250,169,25)",
                  color: "white",
                  fontSize: 18,
                  outline: "none !important",
                  border: "none !important",
                  fontWeight: "500",
                  borderRadius: "5px",
                  width: screenWidth<=1300?'89%':"91%",
                  padding: "9px 2px",
                  textTransform: "uppercase",
                  "&:hover": {
                    backgroundColor: "#e19308",
                  },

                  "& span": {
                    textTransform: "lowercase",
                  },
                }}
                onClick={login}
              >
                Login
              </Button>
            </Box>
          </CustomeLeft>
          <CustomeRight screenWidth={screenWidth}>
            <svg
              className="absolute inset-0 pointer-events-none"
              viewBox="0 0 960 540"
              width="100%"
              height="100%"
              preserveAspectRatio="xMidYMax slice"
              xmlns="http://www.w3.org/2000/svg"
              style={{ color: "#b4b4b463", position: "absolute" }}
              fill="#0367a4"
            >
              <g
                className="opacity-20 MuiBox-root muiltr-1wnrr1p"
                fill="none"
                stroke="currentColor"
                stroke-width="100"
              >
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
              </g>
            </svg>
            <svg
              style={{
                color: "#ffffffa8",
                position: "absolute",
                top: "-44px",
                left: "400px",
                right: -100,
              }}
              className="absolute -top-64 -right-64 opacity-20 MuiBox-root muiltr-x3mbcd"
              viewBox="0 0 220 192"
              fill="#b4b4b463"
            >
              <defs>
                <pattern
                  id="837c3e70-6c3a-44e6-8854-cc48c737b659"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    fill="currentColor"
                  ></rect>
                </pattern>
              </defs>
              <rect
                width="220"
                height="192"
                fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"
              ></rect>
            </svg>
            <Box
              sx={{
                zIndex: 1000,
                width: "100%",
                height: "100%",
                margin: "230px 0 0 60px",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#fff",
                  fontSize:
                    screenWidth <= 1600 ? (screenWidth <= 1400 ? 30 : 40) : 50,
                  fontWeight: "bold",
                  letterSpacing: 2,
                  display: "flex",
                  justifyContent: "start",
                  textAlign: "left",
                }}
              >
                Welcome to <br />
                Ticket System
              </Typography>

              <Typography
                variant="span"
                sx={{
                  color: "#fff",
                  fontSize:
                    screenWidth <= 1600 ? (screenWidth <= 1400 ? 12 : 15) : 17,
                  width: "95%",
                  position: "relative",
                  top: 30,
                  display: "flex",
                  justifyContent: "start",
                  textAlign: "left",
                  wordBreak: " keep-all;",
                  wordWrap: " break-word",
                  whiteSpace: "break-word",
                }}
              >
                The platform helps you manage your company representatives by
                providing state of art features which gives you control and
                unlock your visibility to know all about the team's movements
                and performance
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                left: "35%",
                bottom: "15%",
                borderRadius: "50% !important",
                backgroundColor: "#fff",
                width: "100px",
                height: "100px",
              }}
              className="cir"
            >
              <img
                src={logoComapny}
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundSize: "contained",
                  backgroundPosition: "center center",
                  objectFit: "scale-down",
                }}
              />
            </Box>
          </CustomeRight>
        </CustomeLoginWrapper>
        <div className="area">
          <ul className="circles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </LoginPage>
    );
};
const LoginPage = styled(Box)(({ theme }) => ({
  backgroundColor: "#e1e3e5",
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
}));
const CustomeLoginWrapper = styled(Box)(({ theme, screenWidth }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
  width: screenWidth <= 600 ? "100%" : "70%",
  height: screenWidth <= 600 ? "100%" : "80%",
  borderRadius: screenWidth <= 600 ? 0 : 20,
  boxShadow: "-1.5px 2px 4px -3px rgba(0,0,0,0.75)",
  overflow: "hidden",
  zIndex: 1000,
  paddingTop: screenWidth <= 600 ? "30px" : "0",
}));

const CustomeLeft = styled(Box)(({ theme, screenWidth }) => ({
  display: "flex",
  justifyContent: "start",
  flexDirection: "column",
  alignItems: "start",
  padding: "30px 0 0 40px",
  width: screenWidth <= 1000 ? "100%" : "50%",
  height: "100%",
  "& .imgLogo": {
    width: "300px",
    height: "40px",
    backgroundSize: "cover",
    borderRadius: "50% !important",
  },
}));

const CustomeRight = styled(Box)(({ theme, screenWidth }) => ({
  display: screenWidth <= 1000 ? "none" : "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "50%",
  height: "100%",
  backgroundColor: "#9b9b93",
  position: "relative",
  overflow: "hidden",
}));

const CustomeImageList = styled(Box)(({ theme, screenWidth }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "& .imgItme": {
    width: screenWidth < 1600 ? "46px" : "50px",
    height: screenWidth < 1600 ? "46px" : "50px",
    borderRadius: 50,
    position: "relative",
    outline: "3px solid #006CAD",
  },
  "& .img1": {
    //   left:10,
    zIndex: 60,
  },
  "& .img2": {
    left: "-8px",
    zIndex: 50,
  },
  "& .img3": {
    left: "-15px",
    zIndex: 40,
  },
  "& .img4": {
    zIndex: 30,
    left: "-23px",
  },
}));

const CustomeLanguageDrowpDown = styled(Box)(({ theme, screenWidth }) => ({
  position: "absolute",
  top: 7,
  left: 15,
  width: "100px",
  height: "40px",
  backgroundColor: screenWidth <= 600 ? "rgba(245,247,245,0.7)" : "#FFFFFF",
  borderRadius: 7,
  display: "flex",
  // justifyContent:'center',
  alignItems: "center",
  zIndex: 2000,
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(() => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: useTheme().spacing(1),
    minWidth: 180,
    backgroundColor: "#fff",
    color: "#000",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: useTheme().palette.text.secondary,
        marginRight: useTheme().spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          useTheme().palette.primary.main,
          useTheme().palette.action.selectedOpacity
        ),
      },
    },
    "& .itmlist:hover": {
      backgroundColor: "rgba(255,255,255,0.5)",
    },
  },
}));
export default Login;
